import React from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { Field } from "formik";
import { showFiuuFixedFeeDynamicField } from "../../../utils/terminal_dynamic_util";

const fields = [
  ["base_fix_fee_local", "Base Fixed Fee (Local)"],
  ["markup_fix_fee_local", "Markup Fixed Fee (Local)"],
  ["base_fix_fee_foreign", "Base Fixed Fee (Foreign)"],
  ["markup_fix_fee_foreign", "Markup Fixed Fee (Foreign)"],
];

const FiuuFixedFeeFields = ({ index, values, handleChange, touched, errors, selectedPaymentHost }) => {
  if (!showFiuuFixedFeeDynamicField(selectedPaymentHost)) return null;

  return (
    <Grid container column={8} alignItems="center">
      {fields.map(([name, label]) => (
        <Grid item xs={2} key={name}>
          <Field
            name={`payment.${index}.${name}`}
            validate={(value) => {
              if (value === "" || value === null || value === undefined) return "This field is required";
              if (name.startsWith("base_") && Number(value) < 0) return "Value cannot be negative";
            }}
          >
            {() => (
              <TextField
                required
                sx={{ m: 1 }}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                type="number"
                inputProps={name.startsWith("base_") ? { min: 0 } : undefined}
                label={label}
                id={`payment.${index}.${name}`}
                name={`payment.${index}.${name}`}
                value={values.payment[index][name] ?? "0"}
                onChange={(event) => {
                  const { value } = event.target;
                  if (!name.startsWith("base_") || value === "" || Number(value) >= 0) {
                    handleChange(event);
                  }
                }}
                onKeyDown={(event) => {
                  if (name.startsWith("base_") && event.key === "-") event.preventDefault();
                }}
                error={Boolean(touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name])}
                helperText={touched.payment?.[index]?.[name] && errors.payment?.[index]?.[name]}
                variant="standard"
              />
            )}
          </Field>
        </Grid>
      ))}
    </Grid>
  );
};

export default FiuuFixedFeeFields;
